'use client';

import React from 'react';
import { AgencyOnboarding } from './agency-onboarding';

interface AgencyCandidatesGuardProps {
  children: React.ReactNode;
}

export function AgencyCandidatesGuard({ children }: AgencyCandidatesGuardProps) {
  return <AgencyOnboarding>{children}</AgencyOnboarding>;
}
